import { Box } from '@mui/material';
import styled from 'styled-components';

import BlueCornerImg from '@images/blue-corner.svg';
import vitallLogo from '@images/logos/vitall-logo.svg';

export const CornerImage = styled(Box)((props) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '200px',
  height: '142px',
  zIndex: 50,
  backgroundImage: `url(${BlueCornerImg})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  [props.theme.breakpoints.down('sm')]: {
    width: '120px',
  },
}));

export const LogoImage = styled(Box)((props) => ({
  position: 'absolute',
  top: '30px',
  left: '30px',
  zIndex: 10,
  width: '30%',
  height: '100%',
  backgroundImage: `url(${vitallLogo})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',

  [props.theme.breakpoints.down('sm')]: {
    top: '15px',
    left: '15px',
  },
}));
